import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { FileData } from '../../core/model/massive-load-result';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { CargaMasivaService } from '../../core/services/carga-masiva.service';
import { FileManagerService } from '../../core/services/files/file-manager.service';
import { ToastrService } from 'ngx-toastr';
import { ModalConfirmationComponent } from '../../utils/modal-confirmation/modal-confirmation.component';

@Component({
  selector: 'app-documentation-files-load',
  templateUrl: './documentation-files-load.component.html',
  styleUrls: ['./documentation-files-load.component.css']
})
export class DocumentationFilesLoadComponent implements OnInit {
  @Input() templateId: number;
  @ViewChild('fileInput') fileInput;
  onClose = new Subject<FileData>();
  onFileUploaded = new Subject<FileData[]>();
  fileName = '';
  thinking = false;
  loading = false;

  customMessages = {
    emptyMessage: 'No hay datos que mostrar',
    totalMessage: 'Total',
    selectedMessage: 'Selección'
  };

  customClasses = {
    sortAscending: 'fas fa-sort-up',
    sortDescending: 'fas fa-sort-down',
    pagerLeftArrow: 'fas fa-chevron-left',
    pagerRightArrow: 'fas fa-chevron-right',
    pagerPrevious: 'fas fa-step-backward',
    pagerNext: 'fas fa-step-forward'
  };

  constructor(
    private modalRef: BsModalRef
  ) { }

  ngOnInit() {
  }

  changeFileName() {
    if (this.fileInput.nativeElement.files.length) {
      this.fileName = this.fileInput.nativeElement.files[0].name;
      for (let numFile = 1; numFile < this.fileInput.nativeElement.files.length; numFile++) {
        this.fileName += ', ' + this.fileInput.nativeElement.files[numFile].name;
      }
    } else {
      this.fileName = '';
     }
  }

  private createFileData(file: File, guid?: string): FileData {
    const fileData: FileData = new FileData();
    fileData.filename = file.name;
    fileData.extension = this.getExtension(file.name);
    fileData.size = this.calculateSizeFile(file.size);
    fileData.file = file;
    fileData.guid = guid;

    return fileData;
  }

  private getExtension(filename: string): string {
    const splitPoint = filename.split('.');
    return splitPoint[splitPoint.length - 1];
  }

  private calculateSizeFile(size: number): string {
    const sizeInKb = Math.ceil(size / 1000);
    if (sizeInKb < 1000) {
      return sizeInKb + ' Kb';
    }

    return Math.ceil(sizeInKb / 1000) + ' Mb';
  }

  saveFile() {
    const files: FileData[] = [];
    for (const file of this.fileInput.nativeElement.files) {
      files.push(this.createFileData(file));
     }
    this.onFileUploaded.next(files);
    this.closeModal();
  }


  closeModal() {
    this.modalRef.hide();
  }
}
